import { TicketRedemptionCardType } from '@vista-digital/ocapi-types/v1';
import { logger } from '../../../../utils/logger';
import { mapTicketRedemptionCardPriceToTicketDetails } from '../../../sales-data/mappers/ticket-details';
import { getTicketPricesForMemberSubscription } from '../../../sales-data/selectors/tickets/get-ticket-prices-for-member-subscription';
import { getTicketPricesForThirdPartyMemberScheme } from '../../../sales-data/selectors/tickets/get-ticket-prices-for-third-party-member-scheme';
import { attemptToAddOrderTicketForShowtime } from './attempt-to-add-order-ticket-for-showtime';
/**
 * Attempts to add a ticket for a ticket redemption card in the order.
 *
 * We can only do this when:
 * 1. There is only one [[TicketPrice]] for the ticket redemption card.
 * 2. (Seat first ordering) We have enough remaining tickets to allocate in the ticket type's area category.
 *
 * @returns `true` if the ticket was added or `false` if the ticket could not be added.
 */
export const attemptToAddOrderTicketForRedemptionCard = (showtimeId, ticketRedemptionCard) => {
    const ticketPrices = getTicketPricesForTicketRedemptionCard(showtimeId, ticketRedemptionCard);
    if (ticketPrices.length !== 1) {
        logger.warn(`Attempt to add ticket for ticket redemption card failed. Exactly 1 ticket price is required for showtime '${showtimeId}'. Found '${ticketPrices.length}' ticket prices.`, ticketRedemptionCard);
        return false;
    }
    const ticket = mapTicketRedemptionCardPriceToTicketDetails(ticketPrices[0], ticketRedemptionCard.id);
    return attemptToAddOrderTicketForShowtime(showtimeId, ticket);
};
const getTicketPricesForTicketRedemptionCard = (showtimeId, ticketRedemptionCard) => {
    switch (ticketRedemptionCard.type) {
        case TicketRedemptionCardType.ThirdPartyMemberCard: {
            return getTicketPricesForThirdPartyMemberScheme(showtimeId, ticketRedemptionCard.thirdPartyMemberSchemeId);
        }
        case TicketRedemptionCardType.MemberSubscriptionCard: {
            return getTicketPricesForMemberSubscription(showtimeId, ticketRedemptionCard.subscriptionId);
        }
        default: {
            return []; // card type not supported
        }
    }
};
